import React from 'react';
import PropTypes from 'prop-types';

import Svg from '../../common/components/Svg';

import styles from './contact-banner.scss';

import phoneSvg from './assets/phone.svg';
import envelopeSvg from './assets/envelope.svg';

const ContactBanner = ({ background, headline, content, phone, email }) => (
  <div className={styles.ghostBanner} style={{ backgroundImage: `url('${background}')` }}>
    <div className={styles.contentWrap}>
      <div className={styles.content}>
        <div className={styles.contentInner}>
          <h1>{headline}</h1>
          {content}

          <div className={styles.ctasWrapper}>
            <div className={styles.ctaWrapper}>
              <a href={`tel:${phone}`} className={styles.cta}>
                <Svg src={phoneSvg} className={styles.ctaIcon} />
                Ring oss
              </a>
            </div>
            <div className={styles.ctaWrapper}>
              <a href={`mailto:${email}`} className={styles.cta}>
                <Svg src={envelopeSvg} className={styles.ctaIcon} />
                Maila
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

ContactBanner.propTypes = {
  background: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]).isRequired,
  phone: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

export default ContactBanner;



// WEBPACK FOOTER //
// ./blocks/ContactBanner/index.js